import { Component, OnInit, AfterViewInit, AfterContentInit } from '@angular/core';
declare var $;
@Component({
  selector: 'app-template-wrapper',
  templateUrl: './template-wrapper.component.html',
  styleUrls: ['./template-wrapper.component.css']
})
export class TemplateWrapperComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }

}
